// Utility function to unescape html
export default {
  methods: {
    htmlDecode(str) {
      const doc = new DOMParser().parseFromString(str, 'text/html')
      return doc.documentElement.textContent
    }
  }
}
